export const feedbackTypeSelector = state => state.feedback.type;
export const feedbackMessageSelector = state => state.feedback.message;
